module.exports = __webpack_public_path__ + "static/media/ctf_logo.ddb0a062.svg";